<!-- 打印设置-打印信息设置-销售单打印模板 -->
<template>
  <div class="orderList">
    <el-tabs style="background:white" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="送货参数(未签收)" name="toBeDeliverOrder" lazy>
        <V-TobedeliverOrder></V-TobedeliverOrder>
      </el-tab-pane>
      <el-tab-pane label="结算参数(已签收/历史)" name="toBeConfirmedOrder" lazy>
        <V-Tobeconfirmeorder></V-Tobeconfirmeorder>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VTobedeliverOrder from '@/components/orderPrint/sellOrderSupplierCustomPrint';
import VTobeconfirmeorder from '@/components/orderPrint/toBeConfirmeSupplierPrint';

export default {
  data() {
    return {
      activeName: 'toBeDeliverOrder',
      tabActiveName: sessionStorage.getItem('tabactivename'),
      active: ['toBeDeliverOrder', 'toBeConfirmedOrder', 'historyOrder', 'allOrder', 'orderAuditing', 'orderCheckList'],
    };
  },
  components: {
    VTobedeliverOrder,
    VTobeconfirmeorder,
    // VHistoryorder,
    // VAllorder,
    // VOrderAuditing,
    // VOrderCheckList,
  },
  created() {
    // this.tabActive();
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('tabactivename', this.activeName);
    },
    tabActive() {
      const flag = this.active.find((item) => {
        if (this.tabActiveName == item) {
          return true;
        }
      });
      if (flag) {
        this.activeName = this.tabActiveName;
      }
    },
  },
};
</script>

<style scoped>
.orderList {
  width: 100%;
}

.orderList>>>.el-tabs__item {
  padding-left: 20px !important;
  width: fit-content !important;
}

.orderList>>>.el-tabs__nav-wrap::after {
  height: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/suppliersCustomerPrint.vue